import { wmsPlusHttp, otmsHttp } from '@/utils/http/index';
// import { USER } from '@/constant/storage';
// import { localStorageGet } from '@/utils/localStorage';

// 新增/修改货主
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/11184
export function create(data) {
  return wmsPlusHttp.post('/warehouse_foundation/warehouse/insert_or_update', data);
}

// 获取仓库列表
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/11184
export function getWarehouseList(data, params) {
  return wmsPlusHttp.post('/warehouse_foundation/warehouse/page', data, {
    params,
  });
}

// 仓库禁用启用
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/11184
export function enable(params) {
  return wmsPlusHttp.post('/warehouse_foundation/warehouse/enable', null, { params });
}
// 仓库禁用启用(新)
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/19755
export function updateStatus(data) {
  return wmsPlusHttp.post('/warehouse_foundation/warehouse/update/status', data);
}
// 获取仓库详情
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/11186
export function detail(id) {
  return wmsPlusHttp.get(`/warehouse_foundation/warehouse/get?id=${id}`);
}

// 运营主体下拉菜单
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/11186
export function getTenant(data) {
  return wmsPlusHttp.post('/tenant/list', data);
}

// base接口，根据地址模糊查询
// https://yapi.ops.yunlizhi.cn/project/130/interface/api/8552
export function addressSearch(data) {
  return otmsHttp.post('/poi/list', data);
}

// 发布或者移除云仓
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/12744
export function publishStatusUpdate(data) {
  return wmsPlusHttp.post('/warehouse_foundation/warehouse/publish_status/update', data);
}

// 查询,仓库关联的用户
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/13046
export function warehouseUserSearch(data, params) {
  return wmsPlusHttp.post('/warehouse_foundation/warehouse_user/page', data, { params });
}

// 未绑定的租户用户列表v2
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/24865
export function warehouseUserUnbindSearch(data) {
  return wmsPlusHttp.post('/warehouse_foundation/warehouse_user/unbind/user/v2', data);
}

// 批量解绑用户仓库
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/13042
export function unbindWarehouseUser(data) {
  return wmsPlusHttp.post('/warehouse_foundation/warehouse_user/unbind', data);
}

// 用户绑定仓库
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/13040
export function bindWarehouseUser(data) {
  return wmsPlusHttp.post('/warehouse_foundation/warehouse_user/bind', data);
}
// 给图片加水印
// https://yapi.ops.yunlizhi.cn/project/250/interface/api/15623
export function imageWatermark(data) {
  return otmsHttp.post('/bfs_oss/image/watermark', data);
}
// 获取仓库库位
//  https://yapi.ops.yunlizhi.cn/project/388/interface/api/12022
export function WarehouseLocation(data) {
  return wmsPlusHttp.post('/warehouse_foundation/storehouse/page', data);
}
// 按不同的使用类型来查询库位
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/21153
export function temporaryStorehouse(data) {
  return wmsPlusHttp.post('/warehouse_foundation/storehouse/list/by_usage_type', data);
}
// 按不同的使用类型来查询库位
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/21153
export function temporaryStorehousein(data) {
  return wmsPlusHttp.post('/warehouse_foundation/storehouse/list/by_usage_type', data);
}
// 获取仓库列表
// https://yapi.ops.yunlizhi.cn/project/388/interface/api/19757
export function warehouseList(data, params) {
  return wmsPlusHttp.post('/warehouse_foundation/warehouse/page_v2', data, {
    params,
  });
}
